<template>
  <v-container style="max-width: 1800px !important">
    <div class="pa-3 ma-3">
      <v-alert-dialog ref="alert"> </v-alert-dialog>

      <ValidarProveedor ref="validar_proveedor" @change="getItems">
      </ValidarProveedor>

      <v-dialog v-model="dialogEmail" max-width="60%" persistent>
        <v-card>
          <v-card-title> Solicitar Datos del Proveedor </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="emailItem.email"
                  label="Correo Electrónico"
                  dense
                  outlined
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              color="green"
              @click="closeDialogEmail"
              :loading="loadingEmail"
              >Cancelar</v-btn
            >
            <v-btn text color="red" @click="sendEmail" :loading="loadingEmail"
              >Enviar Solicitud</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogPasswd" persistent max-width="60%">
        <v-card>
          <v-card-title>
            Cambio de Contraseña y Extensión de Tiempo de Acceso
          </v-card-title>
          <v-card-text>
            ¿Desea autorizar el cambio de contraseña para el proveedor
            {{ editedItem.email }} y extender el acceso del usuario a 7 días?
            <br />
            Una vez autorizado, la nueva contraseña se enviará al Proveedor al
            correo electrónico registrado.
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green" text @click="closeDialogPassword">
              Cancelar
            </v-btn>
            <v-btn
              color="red"
              text
              :loading="loadingChangePassword"
              :disabled="loadingChangePassword"
              @click="saveChangePasswd"
            >
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-row>
        <v-col cols="12">
          <v-btn color="primary" @click="openDialogEmail">
            Solicitar Datos a Proveedor
          </v-btn>
        </v-col>
        <v-col cols="12">
          <v-card outlined class="pa-4">
            <div class="caption mb-1 pl-3">Estado de los Expedientes</div>
            <v-row class="pa-0 ma-0 five-columns">
              <!-- Estado 1 - Captura -->
              <v-col class="my-0 py-0 five-col-item">
                <div class="kpi-line">
                  <span class="kpi-figure">{{ pct(stats.captura_per) }}</span>
                  <span class="kpi-pill kpi-pill--grey">
                    {{ nf(stats.captura_num) }} /
                    {{ nf(stats.total) }}
                  </span>
                </div>
                <v-progress-linear 
                  :value="stats.captura_per * 100" 
                  height="8" 
                  color="grey darken-2" 
                  class="mt-2"
                />
                <div class="caption mb-1">Captura</div>
              </v-col>

              <!-- Estado 2 - Reenvío -->
              <v-col class="my-0 py-0 five-col-item">
                <div class="kpi-line">
                  <span class="kpi-figure">{{ pct(stats.reenvio_per) }}</span>
                  <span class="kpi-pill kpi-pill--warning">
                    {{ nf(stats.reenvio_num) }} /
                    {{ nf(stats.total) }}
                  </span>
                </div>
                <v-progress-linear 
                  :value="stats.reenvio_per * 100" 
                  height="8" 
                  color="orange darken-2" 
                  class="mt-2"
                />
                <div class="caption mb-1">Reenvío</div>
              </v-col>

              <!-- Estado 3 - Aceptado -->
              <v-col class="my-0 py-0 five-col-item">
                <div class="kpi-line">
                  <span class="kpi-figure">{{ pct(stats.aceptado_per) }}</span>
                  <span class="kpi-pill kpi-pill--success">
                    {{ nf(stats.aceptado_num) }} /
                    {{ nf(stats.total) }}
                  </span>
                </div>
                <v-progress-linear 
                  :value="stats.aceptado_per * 100" 
                  height="8" 
                  color="green darken-2" 
                  class="mt-2"
                />
                <div class="caption mb-1">Aceptado</div>
              </v-col>

              <!-- Estado 4 - Rechazo -->
              <v-col class="my-0 py-0 five-col-item">
                <div class="kpi-line">
                  <span class="kpi-figure">{{ pct(stats.rechazo_per) }}</span>
                  <span class="kpi-pill kpi-pill--error">
                    {{ nf(stats.rechazo_num) }} /
                    {{ nf(stats.total) }}
                  </span>
                </div>
                <v-progress-linear 
                  :value="stats.rechazo_per * 100" 
                  height="8" 
                  color="red darken-2" 
                  class="mt-2"
                />
                <div class="caption mb-1">Rechazo</div>
              </v-col>

              <!-- Estado 5 - En revisión -->
              <v-col class="my-0 py-0 five-col-item">
                <div class="kpi-line">
                  <span class="kpi-figure">{{ pct(stats.revision_per) }}</span>
                  <span class="kpi-pill kpi-pill--info">
                    {{ nf(stats.revision_num) }} /
                    {{ nf(stats.total) }}
                  </span>
                </div>
                <v-progress-linear 
                  :value="stats.revision_per * 100" 
                  height="8" 
                  color="blue-grey" 
                  class="mt-2"
                />
                <div class="caption mb-1">En Revisión</div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <!--
        <v-col cols="6" class="text-right">
          <v-btn color="primary" text @click="descargarProveedores">
            <v-icon> mdi-download </v-icon>
            Descargar Catálogo de Proveedores
          </v-btn>
        </v-col>
        -->
      </v-row>

      <v-row>
        <v-col cols="4">
          <v-autocomplete
            v-model="search.expediente_estado"
            dense
            hide-details
            outlined
            label="Estado del Expediente"
            :items="expedienteEstados"
            clearable
          >
          </v-autocomplete>
        </v-col>

        <v-col cols="4">
          <v-text-field
            v-model="search.email"
            dense
            hide-details
            outlined
            label="Correo Electrónico"
            clearable
          >
          </v-text-field>
        </v-col>

        <v-col cols="4">
          <v-text-field
            v-model="search.rfc"
            dense
            hide-details
            outlined
            label="RFC"
            clearable  
          >
          </v-text-field>
        </v-col>

        <v-col cols="4">
          <v-text-field
            v-model="search.num_proveedor"
            dense
            hide-details
            outlined
            label="# Proveedor"
            clearable
          >
          </v-text-field>
        </v-col>

        <v-col cols="4">
          <v-autocomplete
            v-model="search.estado_usuario"
            dense
            hide-details
            outlined
            label="Estado del Usuario"
            :items="usuarioEstados"
            clearable
          >
          </v-autocomplete>
        </v-col>

        <v-col cols="4">
          <v-btn
            color="primary"
            text
            outlined
            block
            @click="getItems"
          >
            <v-icon> mdi-magnify </v-icon>
            Buscar
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-data-table :headers="headers" :items="items" :loading="loading">
            <template v-slot:[`item.estado_expediente`]="{ item }">
              <!-- Estado 1 - Captura -->
              <v-tooltip
                bottom
                color="black"
                v-if="item.estado_expediente === 1"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="grey darken-2" v-bind="attrs" v-on="on">
                    mdi-file-edit-outline
                  </v-icon>
                </template>
                <span>
                  Captura: Se está esperando que el proveedor cargue la
                  información y documentación por primera vez
                </span>
              </v-tooltip>

              <!-- Estado 2 - Reenvío -->
              <v-tooltip
                bottom
                color="black"
                v-if="item.estado_expediente === 2"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="orange darken-2" v-bind="attrs" v-on="on">
                    mdi-refresh
                  </v-icon>
                </template>
                <span>
                  Reenvío: Se espera que el proveedor corrija la información y
                  documentación
                </span>
              </v-tooltip>

              <!-- Estado 3 - Aceptado -->
              <v-tooltip
                bottom
                color="black"
                v-if="item.estado_expediente === 3"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="green darken-2" v-bind="attrs" v-on="on">
                    mdi-check-circle
                  </v-icon>
                </template>
                <span>
                  Aceptado: El proveedor fue aceptado y forma parte de los
                  proveedores de Fundación UBGA
                </span>
              </v-tooltip>

              <!-- Estado 4 - Rechazo -->
              <v-tooltip
                bottom
                color="black"
                v-if="item.estado_expediente === 4"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="red darken-2" v-bind="attrs" v-on="on">
                    mdi-close-circle
                  </v-icon>
                </template>
                <span>
                  Rechazo: El proveedor fue rechazado y no podrá formar parte de
                  Fundación UBGA
                </span>
              </v-tooltip>

              <!-- Estado 5 - En revisión -->
              <v-tooltip
                bottom
                color="black"
                v-if="item.estado_expediente === 5"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="blue-grey" v-bind="attrs" v-on="on">
                    mdi-eye-outline
                  </v-icon>
                </template>
                <span>
                  En revisión: La información proporcionada está en proceso de
                  revisión
                </span>
              </v-tooltip>
            </template>

            <template v-slot:[`item.activo`]="{ item }">
              <v-icon v-if="item.activo" color="green darken-2">
                mdi-check-circle
              </v-icon>

              <v-icon v-else color="red darken-4"> mdi-close </v-icon>
            </template>

            <template v-slot:[`item.cambiar_password`]="{ item }">
              {{ item.cambiar_password ? "Si" : "No" }}
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <v-tooltip bottom color="black">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="mr-2"
                    small
                    v-bind="attrs"
                    v-on="on"
                    @click="openDialogPassword(item)"
                  >
                    mdi-key-variant
                  </v-icon>
                </template>
                <span>Autorizar cambio de contraseña</span>
              </v-tooltip>
              <v-tooltip v-if="item.estado_expediente == 5" bottom color="black">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="mr-2"
                    small
                    v-bind="attrs"
                    v-on="on"
                    @click="openValidarProveedor(item)"
                  >
                    mdi-file-search-outline
                  </v-icon>
                </template>
                <span>Iniciar proceso de validación</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import VAlertDialog from "@/components/VAlertDialog.vue";
import ValidarProveedor from "./ValidarProveedor.vue";

export default {
  components: {
    VAlertDialog,
    ValidarProveedor,
  },
  computed: {
    ...mapState(["token"]),
  },
  data: () => ({
    //Main
    headers: [
      {
        text: "Estado del Expediente",
        value: "estado_expediente",
        align: "center",
      },
      {
        text: "Correo Electrónico de Contacto",
        value: "email",
        align: "center",
      },
      {
        text: "RFC",
        value: "rfc",
        align: "center",
      },
      {
        text: "# Proveedor",
        value: "num_proveedor",
        align: "center",
      },
      {
        text: "Estado del Usuario",
        value: "activo",
        align: "center",
      },
      {
        text: "¿Requiere Cambiar Contraseña?",
        value: "cambiar_password",
        align: "center",
      },
      {
        text: "Acceso Valido Hasta",
        value: "acceso_valido_hasta",
        align: "center",
      },
      {
        text: "Ultimo Inicio de Sesión",
        value: "ultimo_login",
        align: "center",
      },
      {
        text: "Acciones",
        value: "actions",
        sortable: false,
        align: "center",
      },
    ],
    items: [],
    loading: false,

    //Dialogo Email
    dialogEmail: false,
    emailItem: {
      email: null,
    },
    defaultEmailItem: {
      email: null,
    },
    loadingEmail: false,

    //Cambiar Password
    editedItem: {
      id_proveedor_usuario: "",
      num_proveedor: "",
      email: "",
      rfc: "",
      activo: false,
      cambiar_password: false,
      ultimo_login: "",
      estado_expediente: "",
      ultima_actualizacion: "",
      acceso_valido_hasta: "",
    },
    defaultEditedItem: {
      id_proveedor_usuario: "",
      num_proveedor: "",
      email: "",
      rfc: "",
      activo: false,
      cambiar_password: false,
      ultimo_login: "",
      estado_expediente: "",
      ultima_actualizacion: "",
      acceso_valido_hasta: "",
    },
    dialogPasswd: false,
    loadingChangePassword: false,

    usuarioEstados: [
      { value: 1, text: "Activo" },
      { value: 2, text: "Caducado" },
    ],
    expedienteEstados: [
      { value: 1, text: "Captura" },
      { value: 2, text: "Reenvío" },
      { value: 3, text: "Aceptado" },
      { value: 4, text: "Rechazo" },
      { value: 5, text: "En Revisión" },
    ],
    search: {
      expediente_estado: null,
      email: null,
      rfc: null,
      num_proveedor: null,
      estado_usuario: null
    },

    stats: {
      total: 0,
      captura_num: 0,
      captura_per: 0,
      reenvio_num: 0,
      reenvio_per: 0,
      aceptado_num: 0,
      aceptado_per: 0,
      rechazo_num: 0,
      rechazo_per: 0,
      revision_num: 0,
      revision_per: 0
    }

  }),
  mounted() {
    this.getItems();
  },
  methods: {
    getItems() {
      const url = new URL(`http://localhost/Proveedores/ListarInvitaciones`);
      if(this.search.expediente_estado != null) url.searchParams.append("estado_expediente", this.search.expediente_estado);
      if(this.search.email != null) url.searchParams.append("email", this.search.email);
      if(this.search.rfc != null) url.searchParams.append("rfc", this.search.rfc);
      if(this.search.num_proveedor != null) url.searchParams.append("clave", this.search.num_proveedor);
      if(this.search.estado_usuario != null) url.searchParams.append("estado_invitacion", this.search.estado_usuario);
      var url_string = url.href.replace("http://localhost", "");

      this.loading = true;
      axios
        .get(url_string)
        .then((response) => {
          this.items = response.data;
          this.calcularEstadisticas();
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openDialogEmail() {
      this.emailItem = Object.assign({}, this.defaultEmailItem);
      this.dialogEmail = true;
    },
    closeDialogEmail() {
      this.emailItem = Object.assign({}, this.defaultEmailItem);
      this.dialogEmail = false;
    },
    sendEmail() {
      this.loadingEmail = true;

      axios
        .post("/Proveedores/CrearInvitacion", {
          email: this.emailItem.email,
        })
        .then(() => {
          this.closeDialogEmail();
          this.getItems();
        })
        .catch((error) => {
          if (error.response.status == 409) {
            this.$refs.alert.setMessage(
              "",
              error.response.data.msg.replace("Error : ", "")
            );
            this.$refs.alert.open();
            return;
          }
          console.log(error);
        })
        .finally(() => {
          this.loadingEmail = false;
        });
    },
    openDialogPassword(editItem) {
      this.editedItem = Object.assign({}, editItem);
      this.dialogPasswd = true;
    },
    closeDialogPassword() {
      this.editedItem = Object.assign({}, this.defaultEditedItem);
      this.dialogPasswd = false;
    },
    saveChangePasswd() {
      this.loadingChangePassword = true;
      axios
        .post(
          "/Proveedores/CambiarPasswordProveedorUsuario/" +
            this.editedItem.id_proveedor_usuario
        )
        .then(() => {
          this.closeDialogPassword();
          this.getItems();
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loadingChangePassword = false;
        });
    },
    nuevaPestana(url) {
      window.open(url, "_blank");
    },
    descargarProveedores() {
      this.nuevaPestana(
        `/api/Proveedores/DescargarProveedores?jwt=${this.token}`
      );
    },
    openValidarProveedor(item) {
      this.$refs.validar_proveedor.open(item.id_proveedor_usuario);
    },
    calcularEstadisticas() {
      // Total de expedientes
      this.stats.total = this.items.length;
      
      if (this.stats.total === 0) {
        // Resetear todos los valores si no hay expedientes
        this.stats.captura_num = 0;
        this.stats.captura_per = 0;
        this.stats.reenvio_num = 0;
        this.stats.reenvio_per = 0;
        this.stats.aceptado_num = 0;
        this.stats.aceptado_per = 0;
        this.stats.rechazo_num = 0;
        this.stats.rechazo_per = 0;
        this.stats.revision_num = 0;
        this.stats.revision_per = 0;
        return;
      }
      
      // Contar expedientes por estado
      this.stats.captura_num = this.items.filter(
        exp => exp.estado_expediente === 1
      ).length;
      
      this.stats.reenvio_num = this.items.filter(
        exp => exp.estado_expediente === 2
      ).length;
      
      this.stats.aceptado_num = this.items.filter(
        exp => exp.estado_expediente === 3
      ).length;
      
      this.stats.rechazo_num = this.items.filter(
        exp => exp.estado_expediente === 4
      ).length;
      
      this.stats.revision_num = this.items.filter(
        exp => exp.estado_expediente === 5
      ).length;
      
      // Calcular porcentajes
      this.stats.captura_per = this.stats.captura_num / this.stats.total;
      this.stats.reenvio_per = this.stats.reenvio_num / this.stats.total;
      this.stats.aceptado_per = this.stats.aceptado_num / this.stats.total;
      this.stats.rechazo_per = this.stats.rechazo_num / this.stats.total;
      this.stats.revision_per = this.stats.revision_num / this.stats.total;
    },
    
    // Función para formatear porcentaje
    pct(value) {
      return `${(value * 100).toFixed(1)}%`;
    },
    
    // Función para formatear números
    nf(value) {
      return value.toLocaleString('es-MX');
    }
  },
};
</script>

<style scoped>
.five-columns {
  display: flex !important;
  flex-wrap: wrap;
}

.five-col-item {
  flex: 0 0 20% !important;
  max-width: 20% !important;
}

/* Estilos para los pills de colores */
.kpi-line {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.kpi-figure {
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 1;
}

.kpi-pill {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  font-weight: 600;
  font-size: 0.85rem;
  line-height: 1.2;
  border: 1px solid transparent;
}

/* Variantes de color para los 5 estados */

/* Estado 1 - Captura (Gris) */
.kpi-pill--grey {
  background: #f5f5f5;   /* grey lighten-4 */
  color: #424242;        /* grey darken-3 */
  border-color: #e0e0e0; /* grey lighten-2 */
}

/* Estado 2 - Reenvío (Naranja/Warning) */
.kpi-pill--warning {
  background: #fff8e1;   /* amber lighten-5 */
  color: #ef6c00;        /* orange darken-3 */
  border-color: #ffe0b2; /* orange lighten-4 */
}

/* Estado 3 - Aceptado (Verde/Success) */
.kpi-pill--success {
  background: #e8f5e9;   /* green lighten-5 */
  color: #2e7d32;        /* green darken-3 */
  border-color: #c8e6c9; /* green lighten-4 */
}

/* Estado 4 - Rechazo (Rojo/Error) */
.kpi-pill--error {
  background: #ffebee;   /* red lighten-5 */
  color: #c62828;        /* red darken-3 */
  border-color: #ffcdd2; /* red lighten-4 */
}

/* Estado 5 - En Revisión (Azul Gris/Info) */
.kpi-pill--info {
  background: #eceff1;   /* blue-grey lighten-5 */
  color: #455a64;        /* blue-grey darken-2 */
  border-color: #cfd8dc; /* blue-grey lighten-3 */
}

@media (max-width: 960px) {
  .five-col-item {
    flex: 0 0 50% !important;
    max-width: 50% !important;
  }
}

@media (max-width: 600px) {
  .five-col-item {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
}
</style>